import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import pdfIcon from '@/assets/img/pdf-icon.png';
import docIcon from '@/assets/img/doc-icon.png';
import store from "@/store";

export default {
  name: "CourseDetail",
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      assignmentData: {},
      assignmentAnswerList: [],
      assignmentAnswerDetail: {},
      assignmentAnswerFiles: [],
      searchData: {
        student_name: '',
      },
      studentName: null,
      activeIndex: null,
      answerId: null,
      remark: '',
      remarkErrMsg: '',
      isLoading: false,
      config: CONFIG,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      pdfIcon,
      docIcon
    };
  },

  computed: {
    normalizedAssignment() {
      return this.normalizeFiles(this.assignmentData?.img_paths || []);
    },
  },

  methods: {
    getAssignmentDetail() {
      axios.get('assignment/detail/' + this.$route.params.id)
        .then((res) => {
          if (res.data) {
            this.assignmentData = res.data;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    normalizeFiles(files) {
      return files.map(file => {
        const ext = file.file_name.split('.').pop().toLowerCase();
        return {
          ...file,
          ext,
          isImage: ['jpg', 'jpeg', 'png'].includes(ext),
          isPdf: ext === 'pdf'
        }
      });
    },

    openImage(imagePath) {
      window.open(imagePath, '_blank');
    },

    async getAssignmentAnswerList(page = 1) {
      await axios.get("assignment-answer/list?page=" + page, {
        params: {
          campus_id: store.state.user.campus_id,
          assignment_id: this.$route.params.id
        }
      }).then((response) => {
        this.assignmentAnswerList = response.data.data;
        this.studentName = '-----------------------';
        this.isLoading = false;
      }).catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    async searchAssignmentAnswer(page = 1) {
      this.isLoading = true;
      this.assignmentAnswerList = [];
      this.assignmentAnswerDetail = {};
      this.assignmentAnswerFiles = [];
      await axios.get("assignment-answer/search?page=" + page, {
        params: {
          campus_id: store.state.user.campus_id,
          assignment_id: this.$route.params.id,
          student_name: this.searchData.student_name
        }
      }).then((response) => {
        this.assignmentAnswerList = response.data.data;
        this.studentName = '-----------------------';
        this.isLoading = false;
      }).catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    async changeAnswer(answerId, name) {
      this.isLoading = true;
      this.studentName = name;
      this.assignmentAnswerDetail = {};
      this.assignmentAnswerFiles = [];
      try {
        const { data } = await axios.get("/assignment-answer/detail/" + answerId);
        this.assignmentAnswerDetail = data;
        this.assignmentAnswerFiles = this.normalizeFiles(data?.answer_files || []);

        await this.$nextTick();
        setTimeout(() => {
          const box = this.$refs.scrollBox;
          const topAnchor = this.$refs.topAnchor;
          if (box && topAnchor) {
            const offsetTop = topAnchor.offsetTop;
            box.scrollTop = offsetTop - 70;
          }
          this.isLoading = false;
        }, 10);
      } catch (error) {
        if (error.response?.status === 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      }
    },

    assignmentAnswerApprove(answerId) {
      if (window.confirm("Are you sure you want to Approve?")) {
        this.isLoading = true;
        axios.post(`/assignment-answer/${answerId}/approve`, {
          status: CONFIG.ASSIGNMENT.STATUS.APPROVED,
        }).then(res => {
          if (res.data.success) {
            this.assignmentAnswerDetail.status = this.config.ASSIGNMENT.STATUS.APPROVED;
            this.$notification.success("Assignment Answer is approved successfully.", {
              timer: 3,
              position: "bottomCenter"
            });
          } else {
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter"
            });
          }
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        })
      }
    },

    showRemarkModel(answerId) {
      this.remarkErrMsg = '';
      this.remark = this.assignmentAnswerDetail.remark || '',
      this.answerId = answerId;
      this.$bvModal.show('remark-modal');
    },

    assignmentAnswerRemark(answerId) {
      if (this.remark && this.remark.length > 255) {
          this.remarkErrMsg = "Remark must be at most 255 characters.";
          return;
      }
      this.remarkErrMsg = "";
      this.$bvModal.hide('remark-modal');
      this.isLoading = true;
      axios.post(`/assignment-answer/${answerId}/remark`, {
        remark: this.remark,
      }).then(res => {
        if (res.data.success) {
          this.assignmentAnswerDetail.remark = this.remark;
          this.$notification.success("Assignment Answer remark successfully.", {
            timer: 3,
            position: "bottomCenter"
          });
        } else {
          this.$notification.error(res.data.message, {
            timer: 3,
            position: "bottomCenter"
          });
        }
        this.isLoading = false;
      }).catch(error => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      })
    },

    toggleActive(index) {
      this.activeIndex = index;
    },

    isActive(index) {
      return this.activeIndex === index;
    },

    isEmpty(obj) {
      return !obj || Object.keys(obj).length === 0;
    },
  },

  mounted() {
    this.isLoading = true;
    this.getAssignmentDetail();
    this.getAssignmentAnswerList();
  },
};
